import getValueAndUnit from "../../../utils/get-value-and-unit";
import setCurrentResolution from "../../../utils/resolutions/set-current-resolution";
import addStorageFunctions from "./add-storage-functions";
import checkCSSVariable from "./check-css-variable";
import setPercentsMethod from "./set-percents-method";
import setValueRefs from "./set-value-refs";

/**
 * Process flat values in (for each resolution)
 * @param {MainClassProps} main
 */
const processStorageValues = (main) => {
  const values = /** @type {Array<StorageItemProps>} */ (
    main?.storage.get("values")
  );

  for (const item of values) {
    const name = /** @type {String} */ (item.get("name"));

    const resolutions = /**@type {ResolutionClusterProps} */ (
      item.get("resolutions")
    );

    for (const [resolution, original] of resolutions) {
      const value = /** @type {String} */ (original || "");
      const checked = checkCSSVariable(main, value);
      const data = getValueAndUnit(checked, item, main);

      if (data.get("is-none-initial") && data.get("is-number")) {
        data.set("output", `calc(0 * ${data.get("output")})`);
      }

      addStorageFunctions(name, data, main);

      resolutions.set(resolution, data);
    }

    /** Select the resolution for the current screen size and add into "current" resolution */
    setCurrentResolution(/**@type {ResolutionProps} */ (resolutions));

    /** Set value (`v_`) and options (`o_`) refs */
    setValueRefs(item, resolutions);

    /** Set the method for calculating percents (for value) */
    setPercentsMethod(item);
  }
};

export default processStorageValues;
